import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Form, { Item, Label, ButtonItem, ButtonOptions, RequiredRule, EmailRule } from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';
import axios from 'axios';

import logo from '../../resources/logo.svg';

// ponytail: reuse create-account (registration) split-screen styles instead of a separate stylesheet
import '../../components/library/registration-form/RegistrationForm.scss';

const emailOptions = { stylingMode: 'outlined', placeholder: 'naam@bedrijf.nl', mode: 'email', height: 34 };

const BrandPanel = () => (
  <div className='reg-right'>
    <div className='reg-right-inner'>
      <h2>WerkbonIQ helpt je op weg met je digitale werkbon.</h2>
      <ul className='reg-features'>
        <li>Werkbonnen digitaal beheren</li>
        <li>Storingen & onderhoud bijhouden</li>
        <li>Klant- en locatiebeheer</li>
        <li>Rapportages & inzichten</li>
      </ul>
    </div>
  </div>
);

export const ForgotPasswordPage = () => {
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [formData] = useState({ email: '' });

  const onSubmit = useCallback(async(e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('/api/Authentication/ForgotPassword', { email: formData.email });
      setSent(true);
    } catch {
      notify('Er is een fout opgetreden. Probeer het later opnieuw.', 'error', 3000);
    } finally {
      setLoading(false);
    }
  }, [formData]);

  if (sent) {
    return (
      <div className='reg-page'>
        <div className='reg-left'>
          <div className='reg-left-inner'>
            <img src={logo} alt='WerkbonIQ' className='reg-logo' />
            <div className='registration-success'>
              <div className='success-icon'>✓</div>
              <h3>E-mail verzonden</h3>
              <p>
                Als dit e-mailadres bij ons bekend is, ontvangt u binnen enkele minuten een e-mail met instructies om uw wachtwoord te herstellen.<br />
                Controleer ook uw spam-map.
              </p>
              <Link to='/login' className='dx-button dx-button-default dx-button-mode-contained success-btn'>
                <span className='dx-button-text'>Terug naar inloggen</span>
              </Link>
            </div>
          </div>
        </div>
        <BrandPanel />
      </div>
    );
  }

  return (
    <div className='reg-page'>
      {/* ── Left: form ── */}
      <div className='reg-left'>
        <div className='reg-left-inner'>
          <img src={logo} alt='WerkbonIQ' className='reg-logo' />
          <h1 className='reg-heading'>Wachtwoord vergeten?</h1>
          <p className='reg-sub'>Vul uw e-mailadres in en we sturen u een link om uw wachtwoord te herstellen.</p>
          <form onSubmit={onSubmit}>
            <Form formData={formData} disabled={loading} showColonAfterLabel={false} showRequiredMark={false}>
              <Item dataField='email' editorType='dxTextBox' editorOptions={emailOptions}>
                <RequiredRule message='E-mailadres is verplicht' />
                <EmailRule message='Ongeldig e-mailadres' />
                <Label text='E-mailadres' />
              </Item>
              <ButtonItem>
                <ButtonOptions width='100%' type='default' useSubmitBehavior>
                  <span className='dx-button-text'>
                    {loading ? <LoadIndicator width='24px' height='24px' visible /> : 'Verstuur herstelmail'}
                  </span>
                </ButtonOptions>
              </ButtonItem>
            </Form>
          </form>
          <div className='reg-footer'>
            <Link to='/login'>Terug naar inloggen</Link>
          </div>
        </div>
      </div>

      {/* ── Right: branding ── */}
      <BrandPanel />
    </div>
  );
};
